"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BusinessMattersOverview() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const services = [{
    course: "CORE",
    name: "Business & Corporate",
    description: "Strategic guidance for formation, ownership planning, contracts, and business purchase or sale.",
    price: "Expert",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/business_corporate.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/business_corporate.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/business_corporate.png-wvc-sizes",
    alt: "Professional business documents and corporate planning",
    link: "/BusinessCorporateServicesPage"
  }, {
    course: "ASSETS",
    name: "Real Estate Law",
    description: "Comprehensive support for real estate transactions and complex ownership transfers in Florida.",
    price: "Trusted",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/real_estate_law.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/real_estate_law.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/real_estate_law.webp-wvc-sizes",
    alt: "Real estate property and legal documentation",
    link: "/RealEstateTransactionsPage"
  }, {
    course: "LEGACY",
    name: "Estate & Probate",
    description: "Estate planning, wills, powers of attorney, and guidance for personal representatives in probate.",
    price: "Secure",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/estate_probate.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/estate_probate.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/estate_probate.png-wvc-sizes",
    alt: "Estate planning and probate legal services",
    link: "/EstatePlanningProbatePage"
  }];
  return;
}